import type { ComponentPropsWithoutRef } from "react"

/**
 * List of supported icon IDs.
 * Add new icon IDs here when adding new symbols to /public/icons.svg.
 */

export const SUPPORTED_ICONS = [
  "logo",
  "logo-effect",
  "logo-footer",
  "press-release",
  "accordion-toggle",
  "instagram",
  "facebook",
  "youtube",
  "linkedin",
  "x",
  "cta-arrow",
  "link-arrow",
] as const

/**
 * Type representing all valid icon IDs.
 */
export type SupportedIcons = (typeof SUPPORTED_ICONS)[number]

type Props = {
  id: SupportedIcons
  title?: string
} & ComponentPropsWithoutRef<"svg">

export const Icon = ({ id, title, ...rest }: Props) => {
  return (
    <svg {...rest} aria-hidden="true">
      {title && <title>{title}</title>}
      <use href={`/icons.svg#${id}`} />
    </svg>
  )
}
